import { observer } from 'mobx-react';

import SteppedComponent from 'js/components/pages/SteppedComponent';
import AppUser from 'js/stores/AppUser';
import AppState from 'js/stores/AppState';
import analytics from 'js/services/Analytics';
import { lightGrey1Color } from 'js/config/style';
import { url } from 'js/services/Network';
import ItemsFileUpload from './ItemsFileUpload';
import UploadSuccess from './UploadSuccess';
import PickupDetails from './PickupDetails';
import SignUpSignIn from './SignUpSignIn';
import UploadItemsPageState from "js/stores/pages/UploadItemsPageState";

@observer
export default class UploadMultipleItems extends SteppedComponent {
  pageName = 'UploadMultipleItemsPage';
  pageColor = lightGrey1Color;

  bootstrap = () => this.page.load();

  pageEvent = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('cv')) {
      analytics.goal('landing_conversion');
      // analytics.track('LP_clicked through', {
      //   location_on_page: params.get('s'),
      // });
    }
  };

  backNav = () =>
    AppUser.isLoggedIn
      ? AppState.previousPage === 'UserDashboardPage'
        ? {
            mode: 'back',
            text: 'Dashboard',
            url: url('user-dashboard-page'),
          }
        : {
            mode: 'back',
            text: 'My items',
            url: url('my-items-page'),
          }
      : { mode: 'normal' };

  page = UploadItemsPageState.create().setSteps(this, 'upload-items-page', [
    {
      name: 'signup',
      label: 'Sign up',
      component: SignUpSignIn,
      skipWhen: (page, step) => AppUser.isLoggedIn,
      onEnter: () => { /*analytics.page('PLC_viewed item Info')*/ },
      showStepMenu: true,
    },
    {
      name: 'pickup-details',
      label: 'Pick-up details',
      component: PickupDetails,
      isComplete: (page, step) => page.address.hasAddress,
      onEnter: () => { /*analytics.page('PLC_viewed pickup address')*/ },
      showStepMenu: true,
    },
    {
      name: 'upload',
      label: 'Select file',
      component: ItemsFileUpload,
      isComplete: (page, step) => page.items.length > 0,
      onEnter: () => { /*analytics.page('PLC_viewed item size')*/ },
      showStepMenu: true,
    },
    {
      name: 'upload-success',
      label: 'Success',
      component: UploadSuccess,
      isCompleted: (page, step) => page.successConfirmation,
      onEnter: () => { /*analytics.page('PLC_viewed item size')*/ },
      showStepMenu: true,
    },
  ]);
}
